module.exports = __webpack_public_path__ + "static/media/3.50264e70.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/swipe/slides/3.png
// module id = 252
// module chunks = 0